var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-1 mr-5",attrs:{"outlined":"","color":"primary"},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" mdi-arrow-left-circle ")]),_vm._v(" Voltar ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }